import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { FaPlus } from 'react-icons/fa'
import Spinner from '../Spinner/Spinner'
import { Table, Button, Alert, Modal, ModalHeader, ModalBody, ModalFooter, Form, Row, Col, Label, Input } from 'reactstrap'
import { JOBS_QUERY, JOB_ACTION_MUTATION } from '../../graphql'
import { handleGraphQLErrors } from '../../utils'
import './Jobs.css'

const JOBS = gql(JOBS_QUERY)
const JOB_ACTION = gql(JOB_ACTION_MUTATION)

export default function Jobs() {
  console.log('Jobs rendered')

  const initialValues = {
    procedureName: '',
    interval: ''
  }
  const [jobs, setJobs] = useState([])
  const [graphQLErrors, setGraphQLErrors] = useState([])
  const [addErrors, setAddErrors] = useState([])
  const [inputs, setInputs] = useState(initialValues)
  const [modal, setModal] = useState(false)
  const [spinner, setSpinner] = useState(false)
  const toggle = () => setModal(!modal)

  async function getJobs() {
    try {
      setSpinner(true)
      const { data, errors } = await window.apolloClient.query({ query: JOBS })
      if (data.jobs) {
        setJobs(data.jobs)
      }
      if (errors) {
        setGraphQLErrors(errors)
      }
    } catch (err) {
      handleGraphQLErrors(err, setGraphQLErrors)
    }
    setSpinner(false)
  }

  useEffect(() => {
    getJobs()
  }, [])

  function handleChange(e) {
    setInputs({ ...inputs, [e.target.name]: e.target.value })
  }

  async function buttonClicked(jobId, action) {
    console.log(`buttonCLicked jobId: ${jobId}, action: ${action}`)
    setSpinner(true)
    try {
      await window.apolloClient.mutate({ mutation: JOB_ACTION, variables: { id: jobId, action: action } })
      getJobs()
    } catch (err) {
      handleGraphQLErrors(err, setGraphQLErrors)
    }
    setSpinner(false)
  }

  async function addClicked() {
    if (!inputs.procedureName || !inputs.interval) {
      setAddErrors([{ message: '"Stored Procedure" and "Interval" are required fields.' }])
    } else {
      try {
        await window.apolloClient.mutate({ mutation: JOB_ACTION, variables: { action: 'ADD', inputs: inputs } })
        toggle()
        getJobs()
        setInputs({ procedureName: '', interval: '' })
      } catch (err) {
        handleGraphQLErrors(err, setAddErrors)
      }
    }
  }

  function cancelClicked() {
    setInputs({ procedureName: '', interval: ''})
    setAddErrors([])
    toggle()
  }

  const rows = []
  for (let job of jobs) {
    const row =
      <tr key={job.id}>
        <td>
          <Button data-cy='job-run-button' color="success" size="sm" style={{ marginRight: '5px'}} onClick={() => { buttonClicked(job.id, 'RUN') }}>Run</Button>
          <Button color="danger" size="sm" style={{ marginRight: '5px'}} onClick={() => { buttonClicked(job.id, 'STOP') }}>Stop</Button>
          <Button color="warning" size="sm" onClick={() => { buttonClicked(job.id, 'DELETE') }}>Delete</Button>
        </td>
        <td data-cy-last-ran={job.lastDate}>{job.lastDate}</td>
        <td>{job.nextDate}</td>
        <td style={{ textAlign: 'center' }}>{job.totalTime}</td>
        <td style={{ textAlign: 'center' }}>{job.interval}</td>
        <td style={{ textAlign: 'center' }}>{job.failures}</td>
        <td style={{ textAlign: 'center' }}>{job.procedure}</td>
        <td style={{ textAlign: 'center' }}>{job.broken}</td>
      </tr>
    rows.push(row)
  }

  let addErrorAlert = ''
  if (addErrors.length > 0) {
    addErrorAlert = <Alert color="danger">{addErrors[0].message}</Alert>
  }

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  }
  if (spinner) {
    return <Spinner />
  }
  return (
    <div className="jobs-page">
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader>Add Job</ModalHeader>
        <ModalBody>
          <Form>
            {addErrorAlert}
            <Row>
              <Col>
                <Label for="procedure-name" style={{ float: 'left'}}>Stored Procedure</Label>
                <Input name="procedureName" id="procedureName" value={inputs.procedureName} onChange={handleChange} />
              </Col>
              <Col>
                <Label for="interval" style={{ float: 'left'}}>Interval</Label>
                <Input name="interval" id="interval" value={inputs.interval} onChange={handleChange} />
              </Col>
            </Row>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button data-cy='add-job-modal-add-button' color="success" onClick={addClicked}>Add</Button>{' '}
          <Button data-cy='add-job-modal-cancel-button' color="secondary" onClick={cancelClicked}>Cancel</Button>
        </ModalFooter>
      </Modal>
      <div className="jobs-container">
        <h3>Job Queue</h3>
        <div className="jobs-grid-table-container">
          <div className="statistics-grid-table-container">
            <Table className="statistics-grid-table" bordered size="sm">
              <thead>
                <tr>
                  <th>
                    <Button data-cy='add-job-button' className="btn-sm" color="success" onClick={toggle}>
                      <FaPlus className="create-icon" /> Job
                    </Button>
                  </th>
                  <th>Last</th>
                  <th>Next</th>
                  <th>Total Time</th>
                  <th>Interval</th>
                  <th>Failures</th>
                  <th>Procedure</th>
                  <th>Broken</th>
                </tr>
              </thead>
              <tbody data-cy-object='Job'>
                {rows}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    </div>
  )
}
